/**
 * Description: File containing constants for audit tool website
 */
export const BATCH_SIZE = 5
export const AMZN_DOMAIN = {
  1: "www.amazon.com",
  44571: "www.amazon.in",
  3: "www.amazon.co.uk",
  4: "www.amazon.de",
  5: "www.amazon.fr",
  35691: "www.amazon.it",
  44551: "www.amazon.es",
  6: "www.amazon.co.jp",
  7: "www.amazon.ca",
  111172: "www.amazon.com.au",
  771770: "www.amazon.com.mx",
  526970:  "www.amazon.com.br",
  328451:  "www.amazon.nl",
  338811:  "www.amazon.sa",
  338801:  "www.amazon.ae"
}
export const MARKETPLACES = [
  {
    "label": "Brazil - 526970",
    "id": "526970"
  },
  {
    "label": "Netherlands - 328451",
    "id": "328451"
  },
  {
    "label": "Saudi Arabia - 338811",
    "id": "338811"
  },
  {
    "label": "United Arab Emirates - 338801",
    "id": "338801"
  },
  {
    "label": "Australia - 111172",
    "id": "111172"
  },
  {
    "label": "Canada - 7",
    "id": "7"
  },
  {
    "label": "France - 5",
    "id": "5"
  },
  {
    "label": "Germany - 4",
    "id": "4"
  },
  {
    "label": "India - 44571",
    "id": "44571"
  },
  {
    "label": "Italy - 35691",
    "id": "35691"
  },
  {
    "label": "Japan - 6",
    "id": "6"
  },
  {
    "label": "Mexico - 771770",
    "id": "771770"
  },
  {
    "label": "Spain - 44551",
    "id": "44551"
  },
  {
    "label": "United Kingdom - 3",
    "id": "3"
  },
  {
    "label": "United States - 1",
    "id": "1"
  }
]

export const UI_DATE_FORMAT = "YYYY-MM-DD"


// WEBPACK FOOTER //
// ./src/components/constants.jsx